import React from "react";
import { Droplets } from "lucide-react";

export const MUD_LEVELS = [
  { value: 1, label: "Dry", color: "bg-[#8FB888]", text: "text-white", border: "border-[#8FB888]", emoji: "🌱" },
  { value: 2, label: "Damp", color: "bg-[#D5B36B]", text: "text-brand-text", border: "border-[#D5B36B]", emoji: "💧" },
  { value: 3, label: "Muddy", color: "bg-[#A36A3D]", text: "text-white", border: "border-[#A36A3D]", emoji: "🟫" },
  { value: 4, label: "Quagmire", color: "bg-[#5C3A1E]", text: "text-white", border: "border-[#5C3A1E]", emoji: "🫧" },
];

export function levelMeta(level) {
  if (!level || level < 1) return null;
  const rounded = Math.max(1, Math.min(4, Math.round(level)));
  return MUD_LEVELS.find((l) => l.value === rounded);
}

/**
 * Small inline badge — use on TrailCard / list rows.
 */
export function MudBadge({ avg, count, testid }) {
  const meta = levelMeta(avg);
  if (!meta || !count) return null;
  return (
    <span
      data-testid={testid || "mud-badge"}
      title={`Mud Meter: ${meta.label} (avg ${avg.toFixed(1)} from ${count} reports)`}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold border ${meta.color} ${meta.text} ${meta.border}`}
    >
      <Droplets size={11} /> {meta.label}
    </span>
  );
}
